import { render } from "./EmojiIcon.vue?vue&type=template&id=423ddb29&scoped=true"
import script from "./EmojiIcon.vue?vue&type=script&lang=js"
export * from "./EmojiIcon.vue?vue&type=script&lang=js"

import "./EmojiIcon.vue?vue&type=style&index=0&id=423ddb29&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423ddb29"]])

export default __exports__